import React from "react";
import UseScrollAnimation from "../Elements/ScrollAnimation";

function PrivacyPolicy() {
  UseScrollAnimation(); // ✅ just call it
  const getHref = (type, value) => {
    switch (type) {
      case "email":
        return `mailto:${value}`;
      case "phone":
        return `tel:${value}`;
      case "map":
        return `https://www.google.com/maps?q=${encodeURIComponent(value)}`;
      default:
        return "#";
    }
  };

  const contactInfo = [
    {
      label: "Email:",
      value: "info@corneliuswoods.net",
      type: "email",
    },
    {
      label: "Call Us:",
      value: "+18886220033",
      display: "(888) 622-0033",
      type: "phone",
    },
    {
      label: "Address:",
      value: "19181 Zion Ave, Cornelius, NC 28031",
      type: "map",
    },
  ];

  return (
    <div className="LocalInformationParent">
      <div className="LocalInformationBox">
        <div className="LocalInformationBoxHeading">
          <span className="LocalInformationBoxHeadingWord animate-top">
            Privacy Policy
          </span>
          <span className="LocalInformationBoxHeadingLine animate-top"></span>
        </div>
        <div className="LocalInformationBoxContentBox">
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              Last Updated: April 8, 2026
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              At Cornelius Woods, we are committed to respecting your privacy.
              This Privacy Policy describes how we collect, use, and protect
              your personal information when you interact with us through our
              website (www.corneliuswoods.com) and when you use our services.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              1. Information We Collect
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              We may collect and store personal information that you voluntarily
              provide to us, such as your name, email address, phone number, and
              other contact information, when you contact us via our website,
              sign up for our newsletter, or inquire about our services. We also
              collect information about your use of our website, including your
              IP address, the type of device you use, your browser type, and the
              pages you visit.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              2. How We Use Your Information
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              We use your personal information to respond to your inquiries,
              provide you with information about our services, and to improve
              our website and services. We may also use this information to send
              you updates and promotional materials, subject to your consent.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              3. Sharing Your Information
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              We do not sell or rent your personal information to third parties.
              We may share your information with third-party service providers
              who help us with our business activities. These companies are
              authorized to use your personal information only as necessary to
              provide these services to us.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              4. Cookies and Other Tracking Technologies
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              We use cookies and other tracking technologies to analyze website
              traffic and to understand where our visitors are coming from. You
              can instruct your browser to refuse all cookies or to indicate
              when a cookie is being sent.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              5. Security
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              We are committed to ensuring the security of your personal
              information. We use appropriate measures to protect the
              information that we collect and store.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              6. Your Choices
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              You have the right to access, correct, or delete your personal
              information at any time. You can also opt out of receiving
              marketing communications from us.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              7. Changes to this Policy
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              We may update this Privacy Policy from time to time. We will
              notify you of any changes by posting the new Privacy Policy on
              this page.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              8. Contact Us
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              If you have any questions about this Privacy Policy, please
              contact us at <br />
              <b>
                {contactInfo.map((item, index) => (
                  <span className="headerTopBoxRightBoxSections00" key={index}>
                    <span className="headerTopBoxRightBoxSectionLabel">
                      {item.label}
                    </span>

                    <a
                      href={getHref(item.type, item.value)}
                      className="headerTopBoxRightBoxSectionInput"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>{item.display || item.value} </span>
                    </a>
                  </span>
                ))}
              </b>
              Please note that this Privacy Policy does not extend to
              third-party websites linked from our website. We recommend that
              you review the privacy policies of those websites before providing
              any personal information.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
